import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Async } from '@/shared/ui/Async';
import { Button } from '@/shared/ui/Button';
import { TextField } from '@/shared/ui/TextField';
import { useSessionStore } from '@/stores/session.store';

import { useChatMessages, useSendMessage } from '../hooks/use-chat';

/** Realtime chat between the two parties of an accepted application (D-011). */
export function ChatPanel({ applicationId }: { applicationId: string }): JSX.Element {
  const { t } = useTranslation();
  const userId = useSessionStore((s) => s.userId);
  const query = useChatMessages(applicationId);
  const send = useSendMessage(applicationId);
  const [body, setBody] = useState('');

  function submit(): void {
    const trimmed = body.trim();
    if (!trimmed) return;
    send.mutate(trimmed, { onSuccess: () => setBody('') });
  }

  return (
    <section className="card stack">
      <h4>{t('chat.title')}</h4>
      <Async query={query} isEmpty={(l) => l.length === 0} emptyMessage={t('chat.empty')}>
        {(messages) => (
          <div className="chat-log">
            {messages.map((m) => (
              <div
                key={m.id}
                className={`chat-bubble${m.senderId === userId ? ' chat-bubble--mine' : ''}`}
              >
                {m.body}
              </div>
            ))}
          </div>
        )}
      </Async>
      <div className="row">
        <TextField
          label={t('chat.message')}
          value={body}
          onChange={(e) => setBody(e.target.value)}
        />
        <Button loading={send.isPending} onClick={submit}>
          {t('chat.send')}
        </Button>
      </div>
    </section>
  );
}
